<template>
	<main-page :user="user" color="blue">
		<template v-slot:title> TVR FEEDBACK </template>

		<div class="container">
			<div class="row content">
				<div class="col-12">
					<v-select
						class="vs-big"
						:options="tvrAssignments"
						label="name"
						:clearable="false"
						v-model="selectedAssignment"
						style="width: 300px"
					/>
				</div>
				<template v-if="selectedAssignment">
					<template v-for="team in teams">
						<div :key="team.id" class="col-12 col-md-4" v-if="user.role != 'PARTNER' && (user.role != 'STUDENT' || userIsOnTeam(team))">
							<div class="mt-3 card">
								<div class="card-header text-md success _600">{{ team.name }}</div>
								<div class="card-body pb-2">
									<div v-for="member in team.members" :key="member.id">
										<div class="d-flex flex-row align-items-center border mb-2">
											<div class="flex">{{ fs.displayName(member.user.name) }}</div>

											<button
												v-if="!member.feedback && selectedAssignment.withinWindow"
												class="btn-no-border btn-si-green btn-si-icon ml-2"
												@click="goToTVR(member.id)"
												v-tippy
												title="Submit TVR Feedback"
											>
												<i class="fas fa-angle-right"></i>
											</button>

											<button
												v-if="!member.feedback && !selectedAssignment.withinWindow"
												class="btn-no-border btn-si-gray btn-si-icon ml-2"
												v-tippy
												title="Submission window closed"
											>
												<i class="fas fa-angle-right"></i>
											</button>

											<button
												v-if="member.feedback && !selectedAssignment.withinWindow"
												class="btn-no-border btn-si-gray btn-si-icon ml-2"
												v-tippy
												title="Already submitted feedback"
											>
												<i class="fas fa-circle"></i>
											</button>

											<button
												v-if="member.feedback && selectedAssignment.withinWindow"
												class="btn-no-border btn-si-blue btn-si-icon ml-2"
												@click="goToTVR(member.id)"
												v-tippy
												title="Edit feedback"
											>
												<i class="fas fa-angle-right"></i>
											</button>
										</div>
									</div>
								</div>
							</div>
						</div>
					</template>
				</template>
			</div>
		</div>

		<template v-slot:footer>
			<div class="col-6 text-right">
				<a class="btn btn-si-secondary" href="#/tvr">Back</a>
			</div>
		</template>
	</main-page>
</template>

<script>
import MainPage from "@/components/MainPage";

import SectionService from "@/services/SectionService";
import TVRService from "@/services/TVRService";
import Notie from "@/services/NotieService";
import fs from "@/services/FormatService";
import BB from "bluebird";
import _ from "lodash";

export default {
	name: "TVRPicker",

	props: ["user"],

	components: { MainPage },

	data() {
		return {
			fs: fs,

			context: null,
			teams: null,
			students: null,
			feedbacks: null,
			tvrTeams: null,
			tvrAssignments: [],
			selectedAssignment: null,
		};
	},

	watch: {
		selectedAssignment() {
			console.log("TVR ASSIGNMENT CHANGED");
			this.constructTVROptions();
		},
	},

	created() {
		this.loadData();
	},

	methods: {
		loadData() {
			BB.props({
				context: SectionService.getContextPrefilled(),
				feedbacks: TVRService.getMyFeedbacks(),
			})
				.then((r) => {
					this.loading = false;
					this.context = r.context.data;
					this.students = this.context.students || [];
					this.teams = this.context.teams;
					this.teams = _.sortBy(this.teams, "name");
					this.tvrAssignments = this.context.tvrs;
					this.feedbacks = r.feedbacks.data;

					_.each(this.tvrAssignments, (ta) => {
						ta.withinWindow = fs.withinWindow(ta.start, ta.end)
					})

					this.tvrAssignments = _.sortBy(this.tvrAssignments, "due_date").reverse();

					if (this.tvrAssignments && this.tvrAssignments.length > 0) {
						this.selectedAssignment = this.tvrAssignments[0];
					}

					_.each(this.teams, team => {
						team.students = _.filter(team.students, s => {
							return this.context.student_ids.includes(s.id)
						})
					});
				})
				.catch((e) => {
					this.loading = false;
					console.log(e);
					Notie.error("Failed to load Team Value Rubrics", e);
				});
		},

		constructTVROptions() {
			if (!this.selectedAssignment) {
				console.log("NO ASSIGNMENT");
				return;
			}

			_.each(this.teams, (team) => {
				team.members = [];
				_.each(team.user_ids, (userID) => {
					let user = _.find(this.students, { id: userID });
					if (!user) {
						console.log(`User ${userID} in team ${team.name} not found`);
					}
					else {
						let feedback = _.find(this.feedbacks, {
							recipient_id: userID,
							assignment_id: this.selectedAssignment.id,
						});

						team.members.push({
							id: user.id,
							user: user,
							feedback: feedback,
						});
					}
				});
			});

			this.$forceUpdate();
		},

		goToTVR(recipientID) {
			if (!(this.selectedAssignment && recipientID)) {
				Notie.error("An error occurred");
				console.error("Cannot proceed to TVR", this.selectedAssignment, recipientID);
				return;
			}

			this.$router.push(`/tvr_form/${this.selectedAssignment.id}/${recipientID}`);
		},

		userIsOnTeam(team) {
			let found = false;
			_.each(team.user_ids, (uid) => {
				console.log("COMPARE", uid, this.user.id);
				if (uid == this.user.id) {
					found = true;
				}
			});

			return found;
		},
	},
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.content {
	margin-top: 3rem;
	margin-bottom: 3rem;
}
.button-container {
	display: flex;
	flex-direction: column;
	width: 170px;
}
</style>
